import moment from 'moment';
import React, { useEffect, useRef } from 'react';
import { setActiveLanguage } from 'react-localize-redux';
import { connect } from 'react-redux';
import { Route, Routes, useNavigate } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useResizeDetector } from 'react-resize-detector';
import { css } from 'glamor';
import './App.css';
import { v4 as uuid } from 'uuid';
import Loader from 'react-loader';
import PrivateRoute from './components/session/PrivateRoute';
import Login from './components/session/Login';
import Logout from './components/session/Logout';
import Navbar from './components/navbar/Navbar';
import store from './store';
import Home from './views/Home';
import Order from './views/Order';
import ChangeOrder from './views/ChangeOrder';
import Destination from './views/Destination';
import InstallationDocument from './views/InstallationDocument';
import InstallationService from './views/InstallationService';
import WorkList from './views/WorkList';
import ServiceSite from './views/ServiceSite';
import ServiceReport from './views/ServiceReport';
import LoggedOut from './views/LoggedOut';
import LoginFailed from './views/LoginFailed';
import Deviations from './views/Deviations';
import { updateSession } from './actions/session';

const AdminLogin = (props) => <Login {...props} admin />;

toast({
  colorDefault: '#EBF6FF',
});

const NavbarWrapper = ({ onResize, children }) => {
  const { height, ref } = useResizeDetector();

  useEffect(() => {
    if (height !== undefined && height !== null) {
      onResize({ height });
    }
  }, [height, onResize]);

  return (
    <div ref={ref} className="App-navbar-top">
      {children}
    </div>
  );
};

const App = ({ updateSession, isSessionRestored, session }) => {
  const mainElementRef = useRef(null);
  const navigate = useNavigate();

  useEffect(() => {
    updateSession(navigate);

    const language = localStorage.getItem('user-language') || 'fi';
    store.dispatch(setActiveLanguage(language));
    moment.locale(language);
  }, [updateSession, navigate]);

  const onNavbarResize = ({ height }) => {
    if (mainElementRef.current) {
      mainElementRef.current.style.paddingTop = `${height}px`;
    }
  };

  if (!isSessionRestored) {
    return <Loader loaded={false} />;
  }

  return (
    <div>
      <NavbarWrapper onResize={onNavbarResize}>
        <Navbar key={session.role} />
      </NavbarWrapper>

      <main ref={mainElementRef}>
        <Routes>
          <Route path="/" element={<PrivateRoute><Home /></PrivateRoute>} />
          <Route path="/order" element={<PrivateRoute><Order /></PrivateRoute>} />
          <Route path="/change_order" element={<PrivateRoute><ChangeOrder /></PrivateRoute>} />
          <Route path="/destination/:destinationId/:page" element={<PrivateRoute><Destination /></PrivateRoute>} />
          <Route path="/installationdocument/:shipmentId/:installationDocumentId" element={<PrivateRoute><InstallationDocument /></PrivateRoute>} />
          <Route path="/servicesite/:destinationId/:serviceSiteId/:page" element={<PrivateRoute><ServiceSite /></PrivateRoute>} />

          <Route
                        key="installationDocumentId"
                        path="/installationservice/:shipmentNumber"
                        element={<PrivateRoute><InstallationService /></PrivateRoute>} />
          <Route
                        key={uuid()}
                        path="/installationservice"
                        element={<PrivateRoute><InstallationService /></PrivateRoute>} />

          <Route path="/servicereport" element={<PrivateRoute><ServiceReport /></PrivateRoute>} />
          <Route path="/servicereport/:reportType/:shipmentId" element={<PrivateRoute><ServiceReport /></PrivateRoute>} />
          <Route path="/worklist" element={<PrivateRoute><WorkList /></PrivateRoute>} />
          <Route path="/deviations" element={<PrivateRoute><Deviations /></PrivateRoute>} />

          {/* Public Routes */}
          <Route path="/login" element={<Login />} />
          <Route path="/admin" element={<AdminLogin />} />
          <Route path="/logout" element={<Logout />} />
          <Route path="/logged_out" element={<LoggedOut />} />
          <Route path="/login_failed" element={<LoginFailed />} />

          {/* Fallback 404 */}
          <Route path="*" element={<div>404</div>} />
        </Routes>
      </main>

      <ToastContainer
                position="bottom-right"
                hideProgressBar
                toastClassName={css({
                  color: '#394a58',
                  outline: '1px solid #50B9FF',
                  fontWeight: 'bold',
                }).toString()} />
    </div>
  );
};

const mapStateToProps = (state) => ({
  isSessionRestored: state.session.isRestored,
  session: state.session.session || {},
});

const mapDispatchToProps = {
  updateSession,
};

export default connect(mapStateToProps, mapDispatchToProps)(App);
